/**
 * receives a date string in ISO format and converts it to a more readable format
 *
 * @param { String } isoString
 * @return a formatted date string
 */
export function convertIsoToDateTime(isoString) {
  const date = new Date(isoString);

  const formatted = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Chicago", // Always set to Central Time
    timeZoneName: "short"
  }).format(date);

  return formatted;
}
